
import { ModuleActionViewEnum } from "../enums/moduleActionViewEnum";

import * as appsettings from "../appsettings";
import * as dialog      from "../dialog";
import * as main        from "../main";
import * as navigation  from "../navigation";
import * as viewmode    from "../viewmode";

function deleteNote(noteId: number): void {
    dialog.closeDialog();

    $.ajax({
        type: "GET",
        url: appsettings.getUrl("Notes/Delete?noteId=" + noteId),
        success: function (responseData) {

            if (responseData != undefined && responseData != null) {
                if (responseData.Succesfully == false) {
                    main.openActionsDialog(' ', responseData.Message,
                        [{ text: 'Ok', action: function () { main.closePopup(); } }]);
                }
            }

            navigation.navigateToSpecificUrl("Notes/Overview");
        }
    });
}

export function showItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // dataItem
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as NotesGridVM;

    // Edit mode form
    viewmode.setViewMode(ModuleActionViewEnum.Show);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("Notes/Edit?noteId=" + dataItem.NoteID + "&breadcrumbLabel=" + "Note");
}


export function editItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    // Prevent default behaviour
    e.preventDefault();

    // dataItem
    const dataItem = this.dataItem($(e.currentTarget).closest("tr")) as NotesGridVM;

    // Edit mode form
    viewmode.setViewMode(ModuleActionViewEnum.Edit);

    // Load create form into the current module div
    navigation.navigateToSpecificUrl("Notes/Edit?noteId=" + dataItem.NoteID + "&breadcrumbLabel=" + "Note");
}


export function deleteItem(e: JQuery.Event & { currentTarget: HTMLElement }): void {

    const event = e;
    const data = this;

    function callbackYes(event: JQuery.Event & { currentTarget: HTMLElement }, data: kendo.ui.Grid): void {
        // Prevent default behaviour 
        event.preventDefault();
        const dataItem = data.dataItem($(event.currentTarget).closest("tr")) as NotesGridVM;
        deleteNote(dataItem.NoteID);
    }

    function callingCallback() {
        callbackYes(event, data);
    }

    dialog.createDialog(callingCallback, function () { });
}

